module.exports = __webpack_public_path__ + "img/MicrosoftTeams-image (19) 1.9ecb8cc9.png";